import styled from 'styled-components';

import theme from '../../assets/theme';

export const Cuributton = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  background: ${theme.colors.orange};
  border-radius: 100px;
  box-shadow: 0px 5px 0px #ef7c23;
  color: white;
  font-weight: bold;
  font-size: 18px;
  max-width: 300px;
  padding: 5px 20px 5px 45px;
  cursor: pointer;
  &:hover {
    box-shadow: 0px 2px 0px #ef7c23;
  }
`;
